import {createRouter, createWebHistory} from 'vue-router'
import LoginPage from "@/pages/login-page.vue";
import HomePage from "@/pages/home-page.vue";

const routes = [
  {
    path: '',
    name: 'home',
    component: HomePage
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    document.querySelector('#top').scrollIntoView({ behavior: 'smooth' })
    return {
      top: 0,
      left: 0,
      behavior: 'smooth'
    }
  }
})

export default router
